/*============================================================================
Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart(forcedToCall = true) {
  $cart = $('#cart');
  // console.log($cart.serialize());
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    type: 'post',
    data: $cart.serialize(),
    success: function (data) {
      refreshCart(data, forcedToCall);
    },
  });
}

function refreshCart(cart, forcedToCall) {
  //const req = await fetch(window.Shopify.routes.root + "?sections=ajax-bag")
  //const res = await req.json()

  $cartBtn = $('.icon-cart span');
  const cartItemCount = cart && cart.item_count ? cart.item_count : 0;
  if ($cartBtn && $cartBtn.size()) {
    var productData = allProducts.products;
    //       var value = $cartBtn.text() || '0';
    var value = cart.item_count ? cart.item_count : '0';
    var cart_items_html = '';
    var $cart = $('#cart ul.inner_ul');
    var cartSpecialMessage = '';

    //alert(shopCurrency);

    $cartBtn.text(value);
    //$cart.find('li:not(:first)').remove();

    //check_for_related();

    if (cart.item_count <= 0) {
      // var freeShippingContentEmpty =
      //   '<div>' +
      //   '<p>' +
      //   Shopify.formatMoney(freeShippingDiff, $cart.data('money-format')) +
      //   ' away from complimentary shipping</p>' +
      //   '<div class="border">' +
      //   '<div class="progress" style="right: ' +
      //   (100 - progress) +
      //   '%"></div>' +
      //   '</div>' +
      //   '</div>';
      $cart.html('');
      // $cart.append("<li class='empty_cart text-center'>Your Bag is Empty</li>");
      $('.cart-button').removeClass('itemincart');
      $('.cart-button').html(
        '<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">' + cart.item_count + '</a>'
      );
      $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));
      $('.addbag_count').hide();
      $('.free-shipping-container').html('');
      $('#cart ul.inner_ul').addClass('hidden');
      $('#cart').removeClass('hidden');
      $('#custom-cart-upsell').addClass('hidden');
      $('.custom-empty-cart').removeClass('hidden');
    } else {
      var freeShipping = $cart.data('free-shipping');
      var freeShippingDiff = freeShipping - cart.total_price;
      var progress = (cart.total_price / freeShipping) * 100;
      if (progress > 100) {
        progress = 100;
      }

      if (cart.item_count > 0) {
        $('#cart ul.inner_ul').removeClass('hidden');
        $('#cart').removeClass('hidden');
        $('#custom-cart-upsell').removeClass('hidden');
        $('.custom-empty-cart').addClass('hidden');
        if (freeShippingDiff > 0) {
          freeShippingContent =
            '<div>\n' +
            '        <p>' +
            Shopify.formatMoney(freeShippingDiff, $cart.data('money-format')) +
            ' away from complimentary shipping</p>\n' +
            '        <div class="border"><div class="progress" style="right: ' +
            (100 - progress) +
            '%"></div></div>\n' +
            '      </div>';
        } else {
          freeShippingContent =
            '<div>\n' +
            '        <p>You’ve received complimentary shipping!</p>\n' +
            '        <div class="border"><div class="progress" style="right: ' +
            (100 - progress) +
            '%"></div></div>\n' +
            '      </div>';
        }
        $('.free-shipping-container').html(freeShippingContent);
      } else {
        $('.free-shipping-container').html('');
        $('#cart ul.inner_ul').addClass('hidden');
        $('#cart').removeClass('hidden');
        $('#custom-cart-upsell').addClass('hidden');
        $('.custom-empty-cart').removeClass('hidden');
      }

      $.each(cart.items, function (index, item) {
        cart_items_html += '';
        cart_items_html +=
          '<li class="cart_item last_cart_item">' +
          '<div class="cart_image" style="background:url(' +
          item.image.replace(/(\.[^.]*)$/, '_large$1').replace('http:', '') +
          ') center center no-repeat;">' +
          '<a href="' +
          item.url +
          '">' +
          '<img src="' +
          item.image.replace(/(\.[^.]*)$/, '_medium$1').replace('http:', '') +
          '" alt="' +
          htmlEncode(item.title) +
          '" style="width:100%" />' +
          '</a>' +
          '</div>' +
          '<div class="cartitem_info">' +
          '<div class="cart item_title full">' +
          '<div class="item_title cart_item_title">' +
          item.product_title +
          '</div>' +
          '<div class="mm-counter cart-quantity">' +
          '<span class="alabel">Quantity</span>' +
          '<div class="cart-quantity">' +
          '<span class="quantity-count minus ss-icon minus">&#x002D;</span>' +
          '<input type="text" min="0" class="quantity" name="updates[]" id="updates_' +
          item.id +
          '" value="' +
          item.quantity +
          '" />' +
          '<span class="quantity-count plus ss-icon plus">&#x002B;</span>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '<div class="cart_item_right" data-qty="' +
          item.quantity +
          '" data-sku="' +
          item.sku +
          '">' +
          '<div class="provar">' +
          '<span style="display:inline-block;">' +
          item.variant_title +
          '</span>' +
          '</div>';

        var planName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null;
        if (planName) {
          cart_items_html += `<div class="cart__content-row">
                         <div class="cart__content-column">
                           <p>S&S</p>
                         </div>
                         <div class="cart__content-column">
                           <p>${planName}</p>
                         </div>
                       </div>`;
        }

        cart_items_html +=
          '</div>' +
          '<div class="cart item_price full">' +
          '<div class="price item_price">' +
          Shopify.formatMoney(item.price, $cart.data('money-format')) +
          '</div>' +
          '<div class="removelink">' +
          '<a href="javascript:void(0)" class="removelink_del" onclick="remove_item(' +
          item.variant_id +
          '); return false;">Remove</a>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</li>';

        //upsell item
        // if (cartItemCount == 1) {
        //   var upsellItemDtls = $('#' + item.handle).val();
        //   const itemIndex = productData.findIndex((el) => el.handle == upsellItemDtls);

        //   if (upsellItemDtls && itemIndex !== -1) {
        //     var productVariants = productData[itemIndex].variants;
        //     var availableVariantIndex = productVariants.findIndex((el) => el.available == true);
        //     if (availableVariantIndex !== -1) {
        //       cart_items_html += '<li class="ajaxUpsellItem cart-item fullset">';
        //       cart_items_html +=
        //         '<input type="hidden" id="upsell-product-' +
        //         productData[itemIndex].variants[availableVariantIndex].id +
        //         '" value="' +
        //         productData[itemIndex].variants[availableVariantIndex].id +
        //         '">';
        //       cart_items_html += '<div class="cart-image">';
        //       cart_items_html += '<a href="' + productData[itemIndex].handle + '" class="fullset">';
        //       cart_items_html += '<img src="' + productData[itemIndex].images[0].src + '" class="fullset"></a></div>';
        //       cart_items_html += '<div class="cart-content">';
        //       cart_items_html += '<div class="cart-contentwrap">';
        //       cart_items_html += '<div class="cart-item-info">' + productData[itemIndex].title + '</div>';
        //       cart_items_html += '<div class="cart-item-price">';
        //       if (productData[itemIndex].variants[availableVariantIndex].compare_at_price) {
        //         cart_items_html +=
        //           '<s>' +
        //           Shopify.formatMoney(
        //             productData[itemIndex].variants[availableVariantIndex].compare_at_price,
        //             $cart.data('money-format')
        //           ) +
        //           '</s>';
        //       }
        //       cart_items_html += Shopify.formatMoney(
        //         productData[itemIndex].variants[availableVariantIndex].price,
        //         $cart.data('money-format')
        //       );
        //       cart_items_html += '</div>';
        //       cart_items_html += '</div>';
        //       cart_items_html +=
        //         '<button type="button" id="' +
        //         productData[itemIndex].variants[availableVariantIndex].id +
        //         '" class="upsell-add-item">Add to Cart</button>';
        //       cart_items_html += '</div>';
        //       cart_items_html += '</li>';
        //     }
        //   }
        // }
      });

      cart_items_html +=
        '<div class="totals_wrapper">' +
        //'<div class="special_cart_message">'+ cartSpecialMessage +'</div>' +
        '<div class="border_btn"><span>Subtotal ' +
        Shopify.formatMoney(cart.total_price, $cart.data('money-format')) +
        '</span><a href="/cart">Checkout</a></div></div>';

      $('.cart-button').addClass('itemincart');

      $('.cart-button').html(
        '<a href="javascript:void(0);" id="cart-number" class="cart-button itemincart">(' + cart.item_count + ')</a>'
      );

      $('.new-total-price').html(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));

      $cart.html(cart_items_html);
      //$cart.append(cart_items_html);
      $cart.find('li.cart_item:last').addClass('last_cart_item');

      if ($('.currencies:visible option:selected').val()) {
        Currency.convertAll($cart.data('shop-currency'), $('.currencies:visible option:selected').val());
      }

      if (!forcedToCall) {
        $('#added-box-wrapper').fadeIn();
      }
      //$(".mobile_success_msg").fadeIn(1500);
      //$(".mobile_success_msg").fadeOut(1500);

      $('span#AddToCartText-product-template').delay(500).text('ADDED!');

      $('.addbag_count').show();
      $('.template-collection .modal').fadeOut();
      $('body').removeClass('modal-open');
      $('.close-reveal-modal').click();

      //
      var wheight = $(window).height();
      var header_height = $('#shopify-section-header').height();
      var boxheight = $('#added-box-wrapper').innerHeight();
      var total_height = $('.totals_wrapper ').innerHeight();

      //$("#added-box-wrapper").css('height', (wheight - header_height - 25));
      //$("#added-box ul").css('height', (boxheight - 207 - 20));

      setTimeout(function () {
        //$("#added-box-wrapper").fadeOut();
      }, 4600);
    }
  }
  var url = '/?section_id=ajax-bag';

  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = data;

      var addedBoxWrapper = tempDiv.querySelector('#added-box-wrapper');
      if (addedBoxWrapper) {
        document.querySelector('#shopify-section-ajax-bag #added-box-wrapper').innerHTML = addedBoxWrapper.innerHTML;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function check_for_related() {
  $('.up_box').each(function (i) {
    var classes = this.classList;
    for (var i = 0, len = classes.length; i < len; i++) {
      if ($('.cart-item-title').hasClass(classes[i])) {
        $(this).addClass('bodySharesClass');
      }
    }
  });
}

function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  } else {
    return '';
  }
}

function remove_item(id) {
  document.getElementById('updates_' + id).value = 0;
  //   document.getElementById('cart').reset();
  ajaxSubmitCart();
  setTimeout(function () {
    $('.up_box').removeClass('bodySharesClass');
    check_for_related();
  }, 1000);
  // if (cart.item_count > 0) {
  //   $('#cart ul.inner_ul').removeClass('hidden');
  //   $('#cart').removeClass('hidden');
  //   $('#custom-cart-upsell').removeClass('hidden');
  //   $('.custom-empty-cart').addClass('hidden');
  // } else {
  //   $('#cart').removeClass('hidden');
  //   $('#cart ul.inner_ul').addClass('hidden');
  //   $('#custom-cart-upsell').addClass('hidden');
  //   $('.custom-empty-cart').removeClass('hidden');
  // }
}

$(document).on('change', '#cart input', function () {
  //alert('1');
  ajaxSubmitCart();
});

$(document).on('click', '.minus', function () {
  var quantity = parseInt($(this).next('input').val());
  var qty = quantity;

  quantity -= 1;
  $(this).next('input').attr('value', quantity);

  if (qty <= 0) {
    $(this).closest('li.cart_item').addClass('animated fadeOutUp');
    setTimeout(ajaxSubmitCart, 500);
  } else {
    ajaxSubmitCart();
  }
  $('.overlay_wrapper').fadeOut();
});

$(document).on('click', '.plus', function () {
  var quantity = parseInt($(this).prev('input').val());
  quantity += 1;
  $(this).prev('input').attr('value', quantity);
  ajaxSubmitCart();
  $('.overlay_wrapper').fadeOut();
});

$(document).on('submit', '.product_form', function (e) {
  e.preventDefault();
  //console.log('test');
  // alert('1')
  var $addToCartForm = $(this);
  var $addToCartBtn = $addToCartForm.find('.add_to_cart');
  //var str1 = $addToCartBtn[0].className;
  var flag = 0;

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    type: 'post',
    data: $addToCartForm.serialize(),
    success: function (itemData) {
      $.getJSON('/cart.js', function (cart) {
        refreshCart(cart);
        window.setTimeout(function () {
          $('.cart-button').click();
        }, 500);
      });
    },
    error: function (XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
      $('.warning').remove();
      var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
      $addToCartBtn.after(warning);
      $addToCartBtn.removeAttr('disabled').removeClass('disabled');
      $addToCartBtn.find('span').text('Add to Bag').removeClass('zoomOut').addClass('zoomIn');
    },
  });
  return false;
});

$(document).on('click', '.upsell-add-item', function (e) {
  e.preventDefault();
  var buttonId = $(this).attr('id');
  console.log(buttonId);
  var productId = parseInt($('#upsell-product-' + buttonId).val());
  var data = {
    quantity: 1,
    id: productId,
  };
  console.log(data);
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    type: 'post',
    data: data,
    success: function (itemData) {
      $.getJSON('/cart.js', function (cart) {
        refreshCart(cart);
        // window.setTimeout(function () {
        //   $(".cart-button").click();
        // }, 500);
      });
    },
    error: function (XMLHttpRequest) {
      console.log(XMLHttpRequest.responseText);
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
    },
  });
  return false;
});
